import React, {useRef} from "react"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {AllowedIncomingAchColumns, IncomingAchColumns} from "./IncomingAch.types"
import {IncomingAch} from "../../resources/incomingAch"
import {Resource} from "../../resources/common"
import {
	DataTable,
	DataTableBody,
	DataTableCell,
	DataTableHead,
	DataTableRow,
} from "../../components/DataTable/DataTable"
import PagingNavBar from "../../components/PagingNavBar/PagingNavBar"
import {Meta} from "../../resources/common"
import {IncomingAchsTableRow} from "./IncomingAchsTableRow"

interface IncomingAchsTableProps {
	incomingAchs: IncomingAch[]
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	isUsingPaging: boolean
	include?: Resource[]
	includedColumns: AllowedIncomingAchColumns[]
	meta?: Meta
	fullHeight?: boolean
	sortFunction: (columnName: string) => void
	sortBy: string
}

export default function IncomingAchsTable({
	incomingAchs,
	fullHeight,
	includedColumns,
	hasNext,
	hasPrev,
	hasResults,
	isUsingPaging,
	include,
	meta,
	prev,
	next,
	sortFunction,
	sortBy,
}: IncomingAchsTableProps) {
	const navigateWithListPath = useNavigateWithListPath()
	const noContent = incomingAchs.length === 0
	const ref = useRef(null)

	return (
		<div ref={ref} className="payments-table">
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={fullHeight}
				noContentText={"No incomingAchs found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === IncomingAchColumns.createdAt) {
								return (
									<DataTableCell
										clickable
										onClick={() => sortFunction("createdAt")}
										key={column[1]}
										sortable={sortBy.includes("createdAt")}
										sortApplied={sortBy === "createdAt"}
									>
										{column[1]}
									</DataTableCell>
								)
							}
							if (column[1] === IncomingAchColumns.amount) {
								return (
									<DataTableCell
										clickable
										onClick={() => sortFunction("amount")}
										key={column[1]}
										sortable={sortBy.includes("amount")}
										sortApplied={sortBy === "amount"}
									>
										{column[1]}
									</DataTableCell>
								)
							}
							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{incomingAchs.map((incomingAch) => (
						<IncomingAchsTableRow
							incomingAch={incomingAch}
							key={incomingAch.id}
							include={include}
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								navigateWithListPath(`/incoming-achs/${incomingAch.id}`)
							}}
							includedColumns={includedColumns}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
				meta={meta}
			/>
		</div>
	)
}
